module.exports = __webpack_public_path__ + "img/collection-engagementRings025Carat.70042cd.jpg";